<template>
  <div class="word_cloud section mx-3">
    <vue-word-cloud
      :words="view_count"
      :color="
        () => this.colors_set[Math.floor(Math.random() * colors_set.length)]
      "
      style="height: 480px; width: 640px; text-align: center"
      font-family="Kanit"
    >
      <template slot-scope="{ text, weight, word }">
        <div :title="weight" style="cursor: pointer" @click="onWordClick(word)">
          {{ text }}
        </div>
      </template>
    </vue-word-cloud>
    <!-- <vue-word-cloud
      style="height: 480px; width: 640px; text-align: center"
      :color="
        () => this.colors_set[Math.floor(Math.random() * colors_set.length)]
      "
      :words="view_count"
      font-family="Kanit"
    /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import VueWordCloud from "vuewordcloud";
import { mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "network_chart",
  components: {
    [VueWordCloud.name]: VueWordCloud,
  },
  data() {
    return {
      colors_set: ["#3B5286", "#5CA7A0", "#CBE54E", "#5D6E1E", "#94B447"],
    };
  },
  mounted() {},
  methods: {
    onWordClick(word) {
      this.$router.push({
        name: "SearchResult",
        query: {
          knowledges_id: '',
          categories_id: '',
          community_id: '',
          keyword: word.text,
        },
      });
    },
  },
  computed: {
    ...mapState({
      view_count: (state) => {
        return state.dashboardModule.view_count;
      },
    }),
  },
};
</script>
<style lang="scss">
.word_cloud {
  display: flex;
  justify-content: center;
}
</style>
